import { Button } from '@/components/ui/Button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu';

type ItemsPerRowSelectorProps = {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  label?: string;
  size?: 'default' | 'sm' | 'lg' | 'icon';
  variant?:
    | 'default'
    | 'outline'
    | 'ghost'
    | 'link'
    | 'destructive'
    | 'secondary';
};

export function ItemsPerRowSelector({
  value,
  onChange,
  min = 1,
  max = 6,
  label = 'Items per row',
  size = 'sm',
  variant = 'outline',
}: ItemsPerRowSelectorProps) {
  const options = Array.from({ length: max - min + 1 }, (_, i) => min + i);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size}>
          {label}: {value}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuRadioGroup
          value={value.toString()}
          onValueChange={(val) => onChange(Number(val))}
        >
          {options.map((num) => (
            <DropdownMenuRadioItem key={num} value={num.toString()}>
              {num} {num === 1 ? 'Item' : 'Items'}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
